// הגדרת ספק AI, מודל ומפתח מהממשק. המפתח נשלח פעם אחת ונשמר מוצפן בשרת — לעולם לא מוחזר לדפדפן.
import { useState } from 'react';
import { api } from '../../api';
import { ErrorBox, Field } from '../ui';
import { useAction } from './common';

interface Status { provider: string; model: string; keys?: { claude: boolean; openai: boolean }; defaultModels?: Record<string, string>; priceInPerM?: number; priceOutPerM?: number }

const LABELS: Record<string, string> = { openai: 'OpenAI', claude: 'Claude (Anthropic)', mock: 'mock — פיתוח בלבד' };

export function AiConfigForm({ status, onSaved }: { status: Status; onSaved: () => void }) {
  const [provider, setProvider] = useState(status.provider);
  const [model, setModel] = useState(status.model);
  const [apiKey, setApiKey] = useState('');
  const [priceIn, setPriceIn] = useState(status.priceInPerM ?? 0);
  const [priceOut, setPriceOut] = useState(status.priceOutPerM ?? 0);
  const act = useAction();
  const hasKey = provider === 'openai' ? status.keys?.openai : provider === 'claude' ? status.keys?.claude : false;
  const changeProvider = (p: string) => { setProvider(p); setModel(status.defaultModels?.[p] ?? ''); setApiKey(''); };
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const ok = await act.run(() => api.put('/api/ai/config', { provider, model, apiKey: apiKey || undefined, priceInPerM: priceIn, priceOutPerM: priceOut }), 'הגדרות ה-AI נשמרו');
    if (ok) { setApiKey(''); onSaved(); window.dispatchEvent(new Event('ai-config-changed')); }
  };
  return (
    <form className="stack" onSubmit={submit} aria-label="הגדרת ספק AI" autoComplete="off">
      <h3 style={{ margin: 0 }}>חיבור ספק</h3>
      <div className="grid cols-2">
        <Field label="ספק">
          <select value={provider} onChange={(e) => changeProvider(e.target.value)}>
            {Object.entries(LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </Field>
        <Field label="מודל" hint="לפי התיעוד הרשמי של הספק"><input className="ltr mono" value={model} onChange={(e) => setModel(e.target.value)} /></Field>
      </div>
      {provider !== 'mock' && (
        <Field label={hasKey ? 'מפתח API (מוגדר — השאירו ריק כדי לא לשנות)' : 'מפתח API'} hint="נשמר מוצפן בשרת ואינו מוצג שוב">
          <input type="password" className="ltr mono" value={apiKey} onChange={(e) => setApiKey(e.target.value)} placeholder={hasKey ? '••••••••' : 'sk-…'} autoComplete="new-password" spellCheck={false} />
        </Field>
      )}
      <div className="grid cols-2">
        <Field label="מחיר קלט ל-1M tokens ($)" hint="לאומדן עלות בלבד"><input type="number" className="ltr" min={0} step="0.01" value={priceIn} onChange={(e) => setPriceIn(Number(e.target.value))} /></Field>
        <Field label="מחיר פלט ל-1M tokens ($)"><input type="number" className="ltr" min={0} step="0.01" value={priceOut} onChange={(e) => setPriceOut(Number(e.target.value))} /></Field>
      </div>
      <ErrorBox error={act.error} />
      <div><button className="btn primary" disabled={act.busy || (provider !== 'mock' && !hasKey && !apiKey)}>{act.busy ? 'שומר…' : 'שמירה'}</button></div>
      <div className="small muted">אחרי שמירה — הריצו "בדיקת חיבור". רק בדיקה מוצלחת מסמנת את הספק כמאומת.</div>
    </form>
  );
}
